import React, { useState } from 'react';
import './Home.css';
import Dashboard2 from "./Dashboard2";
import Fotos from "./Fotos";

const Home = () => {
  return (
    <div className="container">
      
      <Dashboard2/>

      <section className="about">
        <h1>Over Aad van Dam</h1>
        <p>
          Ik ben op latere leeftijd gaan beeldhouwen. Ik ben een autodidact, Ik heb alleen in het juiste gebruik van gereedschap adviezen gehad.
          <br /><br />
          Ik werkt intuïtief, ik laat de steen zeggen, door zijn vorm en kleur, wat hij wil gaan worden. Omgekeerd kan ook, een steen zoeken bij een opdracht.
          <br /><br />
          Ik laat me het liefst uitdagen door een steen, te makkelijk boeit me niet. ik kan ook in opdracht werken.
          <br /><br />
          Ik heb gewerkt met steensoorten zoals: serpentijn, mergel, marmer, opaal, albast, sodaliet en diverse andere soorten steen.
        </p>
      </section>

      <Fotos></Fotos>

    </div>
  );
};

export default Home;
